/**
 * Search-box placeholders for MSR3 payment list tables.
 * Keep consumers importing these constants so copy changes stay single-sourced.
 */

export const PAYMENTS_SEARCH_PLACEHOLDERS = {
  /** ANZ Title Statements — agent. */
  anzTitleAgent: 'Search by title, reference ID, or client',
  /** ANZ Title Statements — non-agent (no client dimension). */
  anzTitleMember: 'Search by title or reference ID',
  /**
   * Client Summary Statements card, every tab, agent or not. The card is
   * scoped to one client (Client column hidden) and shows no Reference ID or
   * Payout Reference ID column, so title is the only searched field a row
   * actually shows. Kept separate from `statementMember` so either can be
   * reworded alone.
   */
  clientSummaryStatements: 'Search by title',
  /** Earnings, both regions: a roll-up has no title or client to search on. */
  earningsReference: 'Search by reference ID',
  /** Disbursements / Residuals — agent. */
  statementAgent: 'Search by title, reference ID, or client',
  /** Disbursements / Residuals — non-agent; reference ID is the Payout Reference ID. */
  statementMember: 'Search by title or reference ID',
  /** World Title Statements — agent. */
  worldTitleAgent: 'Search by title, reference ID, or client',
  /**
   * World Title Statements — non-agent. Same fields as ANZ today;
   * split so Member Services can reword one region without the other.
   */
  worldTitleMember: 'Search by title or reference ID',
} as const;

/** ANZ Title Statements placeholder; omit client for non-agent workspaces. */
export const royaltiesAnzTitleSearchPlaceholder = (isAgent: boolean) =>
  isAgent
    ? PAYMENTS_SEARCH_PLACEHOLDERS.anzTitleAgent
    : PAYMENTS_SEARCH_PLACEHOLDERS.anzTitleMember;

/**
 * World Title Statements placeholder; omit client for non-agent workspaces.
 * Also destined for the title summary statements table once World is wired
 * into it (its ANZ twin is already used there).
 */
export const royaltiesWorldTitleSearchPlaceholder = (isAgent: boolean) =>
  isAgent
    ? PAYMENTS_SEARCH_PLACEHOLDERS.worldTitleAgent
    : PAYMENTS_SEARCH_PLACEHOLDERS.worldTitleMember;

/** Disbursements / Residuals search copy; omits client for non-agent workspaces. */
export const msr3StatementSearchPlaceholder = (isAgent: boolean) =>
  isAgent
    ? PAYMENTS_SEARCH_PLACEHOLDERS.statementAgent
    : PAYMENTS_SEARCH_PLACEHOLDERS.statementMember;
